import React from "react";
import { Box, Modal, Drawer } from "@mui/material";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import {
    IoMdRefresh,
    IoIosRedo,
    IoIosClose,
    IoMdFlag,
} from "react-icons/io";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme, InputBase, IconButton } from "@mui/material";
import { tokens } from "../../../theme";
import { useState } from "react";
import MessageDetails from "./message_details";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";


function Inbox() {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // send mail 


    const [userData, setUserData] = useState("");
    useEffect(() => {
        const currentUserInfo = JSON.parse(localStorage.getItem("authUser"));
        if (currentUserInfo === null || currentUserInfo === "undefined") {
            return setUserData(() => "Please wait...");
        }
        setUserData(currentUserInfo);
        // console.log(userData.displayName, "User Data");
    }, []);
    // styles 
    const modalStyle = {
        "& .modal-content": {
            backgroundColor: colors.primary[400],
            width: "650px"

        },
        "& .modal-header": {
            backgroundColor: colors.primary[500]
        },
        "& #text-editor": {
            backgroundColor: colors.primary[500],
            color: colors.grey[200],
            fontWeight: "400"
        },
        "& .modal-content .form-control": {
            color: colors.grey[200]
        },
        "& .modal-content input::placeholder": {
            color: colors.grey[200]
        },
        "& .modal-title": {
            color: colors.grey[200]
        },


    }

    const style = {
        "& #main": { background: `${colors.primary[400]} !important` },
        "& .title": {
            color: `${colors.blueAccent[600]} !important`
        },
        "& #main .message-list li": {
            color: `${colors.grey[100]} !important`
        },
        "& p": {
            color: colors.grey[300]
        },
        "#message": {
            backgroundColor: colors.primary[400]
        }
        ,
        "#message .message-container li": {
            // border: `1.5px solid ${colors.primary[300]}`,
            backgroundColor: colors.primary[500]
        },
        "a": {
            color: colors.greenAccent[500],
            fontWeight: "600",
            letterSpacing: ".5px"
        },

    }

    // Modal 
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // Reading messages
    const [drawerState, setDrawerState] = useState(false);

    useEffect(() => {
        // set the title of the doc property to inbox 
        document.title = "(43) Inbox | DEEPBLUE CRM";
        var list = document.querySelectorAll(".message-list li");
        list.forEach((lists) => {
            lists.addEventListener('click', (event) => {
                setDrawerState(() => true);
            });
        });

    }, []);

    return (
        <Box mt={11} className="dashboard-section w-100"
            sx={style}
        >
            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="inbox-app-main">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <aside id="sidebar">
                                                <div className="h-100 pb-4" data-simplebar
                                                    style={{ overflowX: "scroll", scrollbarWidth: "thin", }}
                                                >
                                                    <div className="text-center">
                                                        <button
                                                            id="email-left-content"
                                                            type="button"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#custom-modal"
                                                            className=" btn__2-compose mb-2 center width-lg"
                                                            data-animation="fadein"
                                                            data-plugin="custommodal"
                                                            data-overlaycolor="#36404a"
                                                            onClick={handleOpen}
                                                        >
                                                            Compose
                                                        </button>
                                                    </div>

                                                    <menu className="menu-segment">
                                                        <ul className="list-unstyled">
                                                            <li className="active">
                                                                <Link to="" className="flex gap-1">
                                                                    Inbox<span> (43)</span>
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="">Important</Link>
                                                            </li>
                                                            <li>
                                                                <Link to="">Sent</Link>
                                                            </li>
                                                            <li>
                                                                <Link to="">Drafts</Link>
                                                            </li>
                                                            <li>
                                                                <Link to="">Trash</Link>
                                                            </li>
                                                        </ul>
                                                    </menu>

                                                    <div className="separator"></div>

                                                    <div className="menu-segment">
                                                        <ul className="labels list-unstyled">
                                                            <li className="title">
                                                                Labels <span className="icon">+</span>
                                                            </li>
                                                            <li>
                                                                <Link to="#">
                                                                    Dribbble <span className="ball pink"></span>
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#">
                                                                    Roommates <span className="ball green"></span>
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#">
                                                                    Bills
                                                                    <span className="ball blue"></span>
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div className="separator"></div>

                                                    <div className="menu-segment">
                                                        <ul className="chat list-unstyled">
                                                            <li className="title">
                                                                Chat <span className="icon">+</span>
                                                            </li>
                                                            <li>
                                                                <Link to="#">
                                                                    <span className="ball green"></span>Laura
                                                                    Turner
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#">
                                                                    <span className="ball green"></span>Kevin
                                                                    Jones
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#">
                                                                    <span className="ball blue"></span>John King
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#">
                                                                    <span className="ball blue"></span>Jenny
                                                                    Parker
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#">
                                                                    <span className="ball blue"></span>Paul Green
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" className="italic-link">
                                                                    See offline list
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div className="bottom-padding"></div>
                                                </div>
                                            </aside>
                                        </div>
                                        {/* <!-- end col --> */}

                                        <div className="col-md-9">
                                            <main id="main">
                                                <div className="overlay"></div>
                                                <header className="header">
                                                    <h1 className="page-title">
                                                        <Link to="" className="sidebar-toggle-btn__2 trigger-toggle-sidebar">
                                                            <span className="line"></span>
                                                            <span className="line"></span>
                                                            <span className="line"></span>
                                                            <span className="line line-angle1"></span>
                                                            <span className="line line-angle2"></span>

                                                        </Link>
                                                    </h1>
                                                    <div className="action-bar float-start">
                                                        <ul className="list-inline mb-0">
                                                            <li className="list-inline-item">
                                                                <Link to="" className="icon circle-icon">
                                                                    <IoMdRefresh className="text-muted" />
                                                                </Link>
                                                            </li>
                                                            <li className="list-inline-item">
                                                                <Link to="" className="icon circle-icon">
                                                                    <IoIosRedo />
                                                                </Link>
                                                            </li>
                                                            <li className="list-inline-item">
                                                                <Link to="" className="icon circle-icon red">
                                                                    <IoIosClose className="text-danger" />
                                                                </Link>
                                                            </li>
                                                            <li className="list-inline-item">
                                                                <Link to="" className="icon circle-icon red">
                                                                    <IoMdFlag className="text-danger" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <Box
                                                        display="flex"
                                                        float="right"
                                                        m={2}

                                                        height={"2.7rem"}
                                                        width={"13.5rem"}
                                                        right="-55%"
                                                        position={"relative"}

                                                        backgroundColor={colors.primary[500]}
                                                        borderRadius="5rem"
                                                    >
                                                        <InputBase sx={{ ml: 2, flex: 1, }} placeholder="Search..." type="text" className="center flex" />
                                                        <IconButton type="button" sx={{ p: 1.5 }} >
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </Box>

                                                    <div className="clearfix"></div>
                                                </header>

                                                <div id="main-nano-wrapper" className="nano">
                                                    <div className="nano-content h-100" data-simplebar>
                                                        <ul className="message-list">
                                                            <li className="unread">
                                                                <div className="mail-col mail-col-1">
                                                                    <span className="dot"></span>
                                                                    <div className="checkbox-wrapper-mail">
                                                                        <input type="checkbox" id="chk1" />
                                                                        <label
                                                                            htmlFor="chk1"
                                                                            className="toggle"
                                                                        ></label>
                                                                    </div>
                                                                    <p className="title">
                                                                        Lucas Kriebel (via Twitter)
                                                                    </p>

                                                                    <span className="star-toggle far fa-star">

                                                                    </span>
                                                                </div>
                                                                <div className="mail-col mail-col-2">
                                                                    <div className="subject">
                                                                        Lucas Kriebel (@LucasKriebel) has sent you a
                                                                        direct message on Twitter!
                                                                        &nbsp;&ndash;&nbsp;
                                                                        <span className="teaser">
                                                                            @LucasKriebel - Very cool :) Nicklas, You
                                                                            have a new direct message.
                                                                        </span>
                                                                    </div>
                                                                    <div className="date">11:49 am</div>
                                                                </div>
                                                            </li>
                                                            {/* Second Mail */}
                                                            <li>
                                                                <div className="mail-col mail-col-1">
                                                                    <span className="dot"></span>
                                                                    <div className="checkbox-wrapper-mail">
                                                                        <input type="checkbox" id="chk3" />
                                                                        <label
                                                                            htmlFor="chk3"
                                                                            className="toggle"
                                                                        ></label>
                                                                    </div>
                                                                    <p className="title">Randy, me (5)</p>
                                                                    <span className="star-toggle far fa-star">

                                                                    </span>
                                                                </div>
                                                                <div className="mail-col mail-col-2">
                                                                    <div className="subject">
                                                                        Last pic over my village &nbsp;&ndash;&nbsp;
                                                                        <span className="teaser">
                                                                            Yeah i'd like that! Do you remember the
                                                                            video you showed me of your train ride
                                                                            between Colombo and Kandy? The one with
                                                                            the mountain view? I would love to see
                                                                            that one again!
                                                                        </span>
                                                                    </div>
                                                                    <div className="date">5:01 am</div>
                                                                </div>
                                                            </li>
                                                            {/* Third Mail */}
                                                            <li className="blue-dot">
                                                                <div className="mail-col mail-col-1">
                                                                    <span className="dot"></span>
                                                                    <div className="checkbox-wrapper-mail">
                                                                        <input type="checkbox" id="chk4" />
                                                                        <label
                                                                            node htmlFor="chk4"
                                                                            className="toggle"
                                                                        ></label>
                                                                    </div>
                                                                    <p className="title">Andrew Zimmer</p>
                                                                    <span className="star-toggle far fa-star">
                                                                    </span>
                                                                </div>
                                                                <div className="mail-col mail-col-2">
                                                                    <div className="subject">
                                                                        Mochila Beta: Subscription Confirmed
                                                                        &nbsp;&ndash;&nbsp;{" "}
                                                                        <span className="teaser">
                                                                            You've been confirmed! Welcome to the
                                                                            ruling className of the inbox. For your
                                                                            records, here is a copy of the information
                                                                            you submitted to us...
                                                                        </span>
                                                                    </div>
                                                                    <div className="date">Mar 8</div>
                                                                </div>
                                                            </li>
                                                            {/* 4th Mail */}
                                                            <li className="unread">
                                                                <div className="mail-col mail-col-1">
                                                                    <span className="dot"></span>
                                                                    <div className="checkbox-wrapper-mail">
                                                                        <input type="checkbox" id="chk5" />
                                                                        <label
                                                                            htmlFor="chk5"
                                                                            className="toggle"
                                                                        ></label>
                                                                    </div>
                                                                    <p className="title">Infinity HR</p>
                                                                    <span className="star-toggle far fa-star">
                                                                        {" "}
                                                                        {" "}
                                                                    </span>
                                                                </div>
                                                                <div className="mail-col mail-col-2">
                                                                    <div className="subject">
                                                                        Sveriges Hetaste sommarjobb
                                                                        &nbsp;&ndash;&nbsp;
                                                                        <span className="teaser">
                                                                            Hej Nicklas Sandell! Vi vill bjuda in dig
                                                                            till "First tour 2014", ett
                                                                            rekryteringsevent som erbjuder jobb på 16
                                                                            semesterorter iSverige.
                                                                        </span>
                                                                    </div>
                                                                    <div className="date">Mar 8</div>
                                                                </div>
                                                            </li>
                                                            {/* 4th Mail */}
                                                            <li>
                                                                <div className="mail-col mail-col-1">
                                                                    <span className="dot"></span>
                                                                    <div className="checkbox-wrapper-mail">
                                                                        <input type="checkbox" id="chk6" />
                                                                        <label
                                                                            htmlFor="chk6"
                                                                            className="toggle"
                                                                        ></label>
                                                                    </div>
                                                                    <p className="title">Web Support Dennis</p>
                                                                    <span className="star-toggle far fa-star">
                                                                        {" "}
                                                                        {" "}
                                                                    </span>
                                                                </div>
                                                                <div className="mail-col mail-col-2">
                                                                    <div className="subject">
                                                                        Re: New mail settings &nbsp;&ndash;&nbsp;
                                                                        <span className="teaser">
                                                                            Will you answer him asap?
                                                                        </span>
                                                                    </div>
                                                                    <div className="date">Mar 7</div>
                                                                </div>
                                                            </li>
                                                            {/* 4th Mail */}
                                                            <li>
                                                                <div className="mail-col mail-col-1">
                                                                    <span className="dot"></span>
                                                                    <div className="checkbox-wrapper-mail">
                                                                        <input type="checkbox" id="chk7" />
                                                                        <label
                                                                            htmlFor="chk7"
                                                                            className="toggle"
                                                                        ></label>
                                                                    </div>
                                                                    <p className="title">me, Peter (2)</p>
                                                                    <span className="star-toggle far fa-star">
                                                                        {" "}
                                                                        {" "}
                                                                    </span>
                                                                </div>
                                                                <div className="mail-col mail-col-2">
                                                                    <div className="subject">
                                                                        Off on Thursday &nbsp;&ndash;&nbsp;
                                                                        <span className="teaser">
                                                                            Eff that place, you might as well stay
                                                                            here with us instead! Sent from my iPhone
                                                                            4 &gt; 4 mar 2014 at 5:55 pm
                                                                        </span>
                                                                    </div>
                                                                    <div className="date">Mar 4</div>
                                                                </div>
                                                            </li>
                                                            {/* 4th Mail */}
                                                            <li className="orange-dot">
                                                                <div className="mail-col mail-col-1">
                                                                    <span className="dot"></span>
                                                                    <div className="checkbox-wrapper-mail">
                                                                        <input type="checkbox" id="chk8" />
                                                                        <label
                                                                            htmlFor="chk8"
                                                                            className="toggle"
                                                                        ></label>
                                                                    </div>
                                                                    <p className="title">Medium</p>
                                                                    <span className="star-toggle far fa-star">
                                                                        {" "}
                                                                        {" "}
                                                                    </span>
                                                                </div>
                                                                <div className="mail-col mail-col-2">
                                                                    <div className="subject">
                                                                        This Week's Top Stories &nbsp;&ndash;&nbsp;
                                                                        <span className="teaser">
                                                                            Our top pick for you on Medium this week
                                                                            The Man Who Destroyed America’s Ego
                                                                        </span>
                                                                    </div>
                                                                    <div className="date">Feb 28</div>
                                                                </div>
                                                            </li>
                                                            {/* 4th Mail */}
                                                            <li className="blue-dot">
                                                                <div className="mail-col mail-col-1">
                                                                    <span className="dot"></span>
                                                                    <div className="checkbox-wrapper-mail">
                                                                        <input type="checkbox" id="chk9" />
                                                                        <label
                                                                            htmlFor="chk9"
                                                                            className="toggle"
                                                                        ></label>
                                                                    </div>
                                                                    <p className="title">Death to Stock</p>
                                                                    <span className="star-toggle far fa-star">
                                                                        {" "}
                                                                        {" "}
                                                                    </span>
                                                                </div>
                                                                <div className="mail-col mail-col-2">
                                                                    <div className="subject">
                                                                        Montly High-Res Photos &nbsp;&ndash;&nbsp;
                                                                        <span className="teaser">
                                                                            To create this month's pack, we hosted a
                                                                            party with local musician Jared Mahone
                                                                            here in Columbus, Ohio.
                                                                        </span>
                                                                    </div>
                                                                    <div className="date">Feb 28</div>
                                                                </div>
                                                            </li>
                                                            {/* 4th Mail */}
                                                            <li>
                                                                <div className="mail-col mail-col-1">
                                                                    <span className="dot"></span>
                                                                    <div className="checkbox-wrapper-mail">
                                                                        <input type="checkbox" id="chk10" />
                                                                        <label
                                                                            htmlFor="chk10"
                                                                            className="toggle"
                                                                        ></label>
                                                                    </div>
                                                                    <p className="title">Revibe</p>
                                                                    <span className="star-toggle far fa-star">
                                                                        {" "}
                                                                        {" "}
                                                                    </span>
                                                                </div>
                                                                <div className="mail-col mail-col-2">
                                                                    <div className="subject">
                                                                        Weekend on Revibe &nbsp;&ndash;&nbsp;
                                                                        <span className="teaser">
                                                                            Today's Friday and we thought maybe you
                                                                            want some music inspiration for the
                                                                            weekend. Here are some trending tracks and
                                                                            playlists we think you should give a
                                                                            listen!
                                                                        </span>
                                                                    </div>
                                                                    <div className="date">Feb 27</div>
                                                                </div>
                                                            </li>
                                                            {/* 4th Mail */}
                                                            <li>
                                                                <div className="mail-col mail-col-1">
                                                                    <span className="dot"></span>
                                                                    <div className="checkbox-wrapper-mail">
                                                                        <input type="checkbox" id="chk11" />
                                                                        <label
                                                                            htmlFor="chk11"
                                                                            className="toggle"
                                                                        ></label>
                                                                    </div>
                                                                    <p className="title">Erik, me (5)</p>
                                                                    <span className="star-toggle far fa-star">
                                                                        {" "}
                                                                        {" "}
                                                                    </span>
                                                                </div>
                                                                <div className="mail-col mail-col-2">
                                                                    <div className="subject">
                                                                        Regarding our meeting &nbsp;&ndash;&nbsp;
                                                                        <span className="teaser">
                                                                            That's great, see you on Thursday!
                                                                        </span>
                                                                    </div>
                                                                    <div className="date">Feb 24</div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        <Link to="#" className="load-more-link mt-5"
                                                            style={{
                                                                color: `${colors.blueAccent[400]} `
                                                            }}
                                                        >
                                                            Show more messages
                                                        </Link>
                                                    </div>
                                                </div>
                                            </main>
                                            {/* Message should be pull out from here */}
                                        </div>
                                        {/* <!-- end col --> */}
                                        {/* Call drawer here */}
                                        {/* Drawer */}
                                        <Box>
                                            <Drawer
                                                anchor="right"
                                                open={drawerState}
                                                onClose={() => setDrawerState(false)}
                                            >
                                                <MessageDetails style={style} state={() => setDrawerState(false)} />
                                            </Drawer>
                                        </Box>
                                    </div>
                                    {/* <!-- end row --> */}
                                </div>
                            </div>
                        </div>
                        {/* End row  */}
                    </div>
                    {/*  end content  */}
                </div>
            </div>
            {/* <!-- End wrapper --> */}
            {/* <!-- Modal --> */}
            <Box className="modal-wrapper">
                <Modal
                    open={open}
                    onClose={handleClose}
                    className="modal d-block"
                    id="custom-modal"
                    tabindex="-1"
                    role="dialog"
                    aria-hidden="false"
                >
                    <Box className="modal-dialog modal-dialog-centered"
                        sx={modalStyle}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" id="myCenterModalLabel">
                                    Compose Mail
                                </h4>
                                <button
                                    type="button"
                                    className="btn__2-close"
                                    data-bs-dismiss="modal"
                                    aria-hidden="true"
                                    onClick={handleClose}
                                ></button>
                            </div>

                            <h5 className="modal-body">
                                <form >
                                    <div className="mb-3">
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="To"
                                        />
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Cc"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Bcc"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Subject"
                                        />
                                    </div>
                                    {/* TODO:Add a react text editor  */}
                                    <div className="mb-3 card border-0">
                                        <div id="text-editor" style={{ height: "250px" }}>
                                            <Editor
                                            />
                                        </div>
                                        {/* <!-- end Snow-editor--> */}
                                    </div>

                                    <div className="btn__2-toolbar">
                                        <div className="flex">
                                            <button
                                                type="button"
                                                className="btn-2 btn-2-success waves-effect waves-light me-1"
                                            >
                                                <i className="far fa-save"></i>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn-2 btn-2-success waves-effect waves-light me-1"
                                            >
                                                <i className="far fa-trash-alt"></i>
                                            </button>
                                            <button className="btn-2 btn-2-purple waves-effect waves-light flex">
                                                <span className="">Send</span>
                                                <i className="fas fa-paper-plane ms-1"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </h5>
                        </div>
                    </Box>
                </Modal>
            </Box>
        </Box>
    );
}

export default Inbox;
